import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'large-number-display',
  templateUrl: './large-number-display.component.html'
})
export class LargeNumberDisplayComponent implements OnInit {
  @Input() public number: number;
  @Input() public text: string;
  @Input() public class: string;
  @Output() onClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }
}
